var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"saas-progress-bar"},[_c('div',{staticClass:"saas-progress-bar__fill",class:'saas-progress-bar__fill--' + _vm.colorClass,style:({ width: `${_vm.percentage}%` })})])
}
var staticRenderFns = []

export { render, staticRenderFns }